import { createRouter, createWebHistory } from "@ionic/vue-router";
import { RouteRecordRaw } from "vue-router";
import { api } from "@/api";
import { Device } from "@capacitor/device";
import { Preferences } from "@capacitor/preferences";
import useScoreStore from "@/stores/scoreStore";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    meta: {
      showPlayerMenu: true,
      guest: true,
    },
    component: () => import("@/views/welcome.vue"),
  },
  {
    path: "/infos",
    name: "infos",
    meta: {
      showPlayerMenu: true,
      guest: false,
    },
    component: () => import("@/views/infos.vue"),
  },
  {
    path: "/choose-character",
    name: "choose_character",
    meta: {
      showPlayerMenu: true,
      guest: false,
    },
    component: () => import("@/views/choose-character.vue"),
  },
  {
    path: "/choose-theme/:character_id",
    name: "choose_theme",
    meta: {
      showPlayerMenu: true,
      guest: false,
    },
    component: () => import("@/views/choose-theme.vue"),
  },
  {
    path: "/theme-intro/:id/:character_id",
    name: "theme_intro",
    meta: {
      showPlayerMenu: true,
      guest: false,
    },
    component: () => import("@/views/theme-intro.vue"),
  },
  {
    path: "/quiz/:theme_id/:level_id",
    name: "quiz",
    meta: {
      showPlayerMenu: false,
      guest: false,
    },
    component: () => import("@/views/quiz.vue"),
  },
  {
    path: "/final/:theme_id/:level_id",
    name: "final",
    meta: {
      showPlayerMenu: false,
      guest: false,
    },
    component: () => import("@/views/final.vue"),
  },
  {
    path: "/reward/:theme_id/:level_id",
    name: "reward",
    meta: {
      showPlayerMenu: false,
      guest: false,
    },
    component: () => import("@/views/reward.vue"),
  },
  {
    path: "/settings",
    name: "settings",
    meta: {
      showPlayerMenu: false,
      guest: false,
    },
    component: () => import("@/views/settings.vue"),
  },
  {
    path: "/delete-account",
    name: "delete_account",
    meta: {
      showPlayerMenu: false,
      guest: false,
    },
    component: () => import("@/views/delete_account.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const isValid = await infoFilled();
  const characterResponse = await Preferences.get({ key: "CHARACTER_ID" });

  if (isValid) {
    if (to.meta.guest) {
      next({
        name: "choose_theme",
        params: { character_id: characterResponse.value },
      });
    } else {
      next()
    }
  } else {
    next();
  }
});

router.afterEach((to, from, next) => {
  const scoreStore = useScoreStore();

  if (to.query?.resetScore == "1") {
    scoreStore.reset();
  }
});

const infoFilled = async () => {
  try {
    const device = await Device.getId()
    await api().get(`/player/${device.identifier}`);
    return true;
  } catch(e) {
    return false;
  }
};

export default router;